import { render, staticRenderFns } from "./MpChooseAnswer16.vue?vue&type=template&id=8b25f85e&scoped=true&"
import script from "./MpChooseAnswer16.vue?vue&type=script&lang=js&"
export * from "./MpChooseAnswer16.vue?vue&type=script&lang=js&"
import style0 from "./MpChooseAnswer16.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MpChooseAnswer16.vue?vue&type=style&index=1&id=8b25f85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b25f85e",
  null
  
)

export default component.exports